// https://github.com/hadeeb/react-lazy-hydration/blob/master/src/isBrowser.ts
export const isBrowser = typeof document !== 'undefined';